import { NgModule } from "@angular/core";
import { LanguagesServiceProvider } from './languages.service.upgrade';
import { UrlServiceProvider } from './urlService.upgrade';
import { AuthService } from "./auth.service";
import { StorageService } from "./storageService.service";
import { UserFormatService } from "./userformat.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { UrlAirlineInterceptor } from "./interceptors/urlAirline.interceptor";
import { UrlLanguageInterceptor } from "./interceptors/urlLanguage.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { CacheInterceptor } from "./interceptors/cache.interceptor";
import { AppsService } from "./applications.service";
import { CookieService } from "./cookie.service";

@NgModule({
    providers: [
        LanguagesServiceProvider,
        UrlServiceProvider,
        AuthService,
        StorageService,
        UserFormatService,
        AppsService,
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: UrlAirlineInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: UrlLanguageInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
    ]
})
export class AppServicesModule {}
